import Link from 'next/link';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import MapCordinateContext from '@/context/MapCordinateContext';
import { capitalizeFirstLetterOfWords } from '@/helper/wordReplace';

import ImageSlider from './image-gallery-slide';
import AddressComponent from './revamp/address';
import MapView from './revamp/map-view';
import StorePromotions from './revamp/store-promotions';
import TitleDescription from './revamp/title-desc';
import TopFeatures from './revamp/top-features';
import StoreHours from './store-hours';

const MobileBanner = (props: any) => {
  const { facilityData, ratingData, promotions } = props;
  const citySlug = facilityData?.attributes?.City_Slug;
  const { query, locale, asPath }: any = useRouter();

  const cords = useContext(MapCordinateContext);
  const getCity = query && query.location && query.location[0];
  const getStore =
    query && query.location && query.location[1]
      ? facilityData?.attributes?.Title
      : null;
  const cityName = capitalizeFirstLetterOfWords(getCity);
  const cityStore = capitalizeFirstLetterOfWords(getStore);
  const handleClick = () => {
    cords.setLatLog({});
    cords.setLatLogCity({});
  };
  useEffect(() => {
    const switchLocale = JSON.parse(sessionStorage.getItem('switchLocale'));
    const currentUrl = {
      path: asPath,
      locale,
      domain: process.env.NEXT_PUBLIC_SITE_URL_ORIGIN,
      switchLocale,
    };
    const preRoute = JSON.parse(sessionStorage.getItem('preRoute'));
    const getPreRoute = JSON.parse(sessionStorage.getItem('prevRoute'));
    const getUpdateRoute = JSON.parse(sessionStorage.getItem('updateRou'));
    if (
      getPreRoute &&
      getPreRoute.locale === locale &&
      (preRoute !== getUpdateRoute || (!preRoute && !getUpdateRoute))
    ) {
      sessionStorage.setItem('preRoute', JSON.stringify(currentUrl));
      sessionStorage.setItem('switchLocale', JSON.stringify(locale));
    } else if (preRoute && locale !== switchLocale) {
      sessionStorage.setItem('updateRou', JSON.stringify(currentUrl));
      sessionStorage.setItem('prevRoute', null);
    } else if (getUpdateRoute && preRoute && preRoute !== getUpdateRoute) {
      sessionStorage.setItem('preRoute', JSON.stringify(currentUrl));
      sessionStorage.setItem('prevRoute', null);
    } else if (!preRoute && !getUpdateRoute && !getPreRoute) {
      sessionStorage.setItem('preRoute', JSON.stringify(currentUrl));
      sessionStorage.setItem('switchLocale', JSON.stringify(locale));
    }
  }, [facilityData]);

  return (
    <>
      <section>
        <div className="container">
          <section className="sv-breadcrumb-revamp">
            <nav aria-label="breadcrumb" className="d-flex">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link href="/" prefetch={false}>
                    {locale === 'en' ? 'Home' : 'Accueil'}
                  </Link>
                </li>
                <li className="breadcrumb-separator"></li>
                <li className="breadcrumb-item">
                  <Link
                    href={
                      locale === 'en'
                        ? '/en/self-storage'
                        : '/entreposage-libre-service'
                    }
                  >
                    <a onClick={handleClick}>
                      {locale === 'en' ? 'Locations' : 'Succursales'}
                    </a>
                  </Link>
                </li>
                {query?.location[0] && query?.location[1] && !citySlug ? (
                  <>
                    <li className="breadcrumb-separator"></li>
                    <li className="breadcrumb-item">
                      <Link
                        href={`${
                          locale === 'en'
                            ? '/en/self-storage'
                            : '/entreposage-libre-service'
                        }/[...location]`}
                        as={`${
                          locale === 'en'
                            ? '/en/self-storage'
                            : '/entreposage-libre-service'
                        }/${query?.location[0]}`}
                      >
                        <a>{cityName}</a>
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                    <li className="breadcrumb-separator"></li>
                    <li className="breadcrumb-item active">{cityName}</li>
                  </>
                )}
                {cityStore && (
                  <>
                    <li className="breadcrumb-separator"></li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {cityStore}
                    </li>
                  </>
                )}
              </ol>
            </nav>
          </section>
        </div>
        <div className="gallery">
          {facilityData?.attributes?.Facility_Gallery && (
            <ImageSlider
              images={facilityData?.attributes?.Facility_Gallery}
              isMobile={true}
              promotions={promotions}
            />
          )}
        </div>
        <div className="container">
          <TitleDescription
            facilityData={facilityData}
            ratingData={ratingData}
          />
        </div>
      </section>

      <section>
        <div className="container">
          <AddressComponent facilityData={facilityData} />
        </div>
      </section>

      <section className="sv-store-features-tabs">
        <div className="container">
          <ul
            className="nav nav-tabs d-flex w-100 flex-nowrap p-0 m-0"
            id="myTab"
            role="tablist"
          >
            <li className="nav-item flex-fill text-center" role="presentation">
              <button
                className="nav-link active w-100"
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home-tab-pane"
                type="button"
                role="tab"
                aria-controls="home-tab-pane"
                aria-selected="true"
              >
                <span className="tab-img">
                  <img src="/images/sv-maps-icon.svg" alt="Maps" />
                </span>
                <FormattedMessage id="map" />
              </button>
            </li>
            <li className="nav-item flex-fill text-center" role="presentation">
              <button
                className="nav-link w-100"
                id="features-tab"
                data-bs-toggle="tab"
                data-bs-target="#features-tab-pane"
                type="button"
                role="tab"
                aria-controls="features-tab-pane"
                aria-selected="false"
              >
                <span className="tab-img">
                  <img src="/images/sv-features-icon.svg" alt="features" />
                </span>
                <FormattedMessage id="features" />
              </button>
            </li>
            <li className="nav-item flex-fill text-center" role="presentation">
              <button
                className="nav-link w-100"
                id="hours-revamp-tab"
                data-bs-toggle="tab"
                data-bs-target="#hours-revamp-tab-pane"
                type="button"
                role="tab"
                aria-controls="hours-revamp-tab-pane"
                aria-selected="false"
              >
                <span className="tab-img">
                  <img src="/images/sv-alarm-clock-icon.svg" alt="hours" />
                </span>
                <FormattedMessage id="hours" />
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="home-tab-pane"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <MapView facilityData={facilityData} />
            </div>
            <div
              className="tab-pane fade"
              id="features-tab-pane"
              role="tabpanel"
              aria-labelledby="features-tab"
            >
              <TopFeatures facilityData={facilityData} />
            </div>
            <div
              className="tab-pane fade"
              id="hours-revamp-tab-pane"
              role="tabpanel"
              aria-labelledby="hours-revamp-tab"
            >
              <StoreHours
                openHours={facilityData?.attributes?.Open_Hours}
                storeHours={facilityData?.attributes?.Store_Hours}
              />
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <StorePromotions promotions={promotions} />
      </div>
    </>
  );
};

export default MobileBanner;
